import { PureLightTheme } from '../../../styles/theme'
import { COLORS } from '../../../styles/variables'

export const BoxWelcome = {
  textAlign: 'center',
  margin: '0 0 48px 0',
  maxWidth: '520px',
  marginLeft: 'auto',
  marginRight: 'auto',

  [PureLightTheme.breakpoints.down('lg')]: {
    marginBottom: '40px',
  },
}

export const H1Welcome = {
  margin: '0 0 12px 0',
  color: COLORS.CERULEAN,
  fontWeight: 700,
  fontSize: '40px',
  lineHeight: 1.15,
  letterSpacing: '-0.02em',

  [PureLightTheme.breakpoints.down('md')]: {
    fontSize: '34px',
  },

  [PureLightTheme.breakpoints.down('sm')]: {
    fontSize: '28px',
  },
}

export const H2Welcome = {
  color: COLORS.CHARCOAL_GREY,
  fontWeight: 400,
  fontSize: '18px',
  lineHeight: 1.5,
  margin: '0 auto',
  maxWidth: '420px',

  [PureLightTheme.breakpoints.down('sm')]: {
    fontSize: '15px',
    maxWidth: '320px',
  },
}

export const ImageWelcome = {
  width: '100%',
  height: 'auto',
  maxWidth: '626px',
  display: 'block',
  margin: '0 auto',
}
